export default "__VITE_ASSET__CmM5VJLi__"